import { useQuery } from '@tanstack/react-query'

import { queryKeys } from 'api/consts'

import { fetchUser } from './api'

import type { FetchUserResponse } from './types'

export const useUserQuery = <T = FetchUserResponse>(
  { select }: { select?: (data: FetchUserResponse & { user: { availableLanguages: string[] } }) => T } = {},
) => useQuery({
  queryFn: () => fetchUser(),
  queryKey: [queryKeys.user],
  select,
})
